<template>
    <div class="qr-shell" :class="{ 'qr-shell--connection-banner': connectionBanner }">
        <router-view></router-view>
        <QrToast />
        <ConnectionBanner :status="connectionBanner" />
    </div>
</template>

<script setup>
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import QrToast from '../../components/qr/QrToast';
import ConnectionBanner from '../../components/qr/ConnectionBanner';
import { useConnectionStatus } from '../../composables/qr/useConnectionStatus';
import { useQrVisitorContext } from '../../composables/qr/useQrVisitorContext';

const route = useRoute();
const store = useStore();
const visitor = useQrVisitorContext();
const { banner: connectionBanner } = useConnectionStatus();
watch(() => route.params.entranceId, entranceId => {
    if (!entranceId || entranceId === store.getters['qr/entranceId']) return;
    if (store.getters['qr/entranceId']) visitor.resetVerification();
    store.dispatch('qr/loadEntrance', entranceId);
}, { immediate: true });
</script>

<style scoped>
.qr-shell {
    --qr-connection-space: 0px;
    display: flex;
    min-height: 100%;
    flex-direction: column;
    padding-bottom: var(--qr-connection-space);
}

.qr-shell--connection-banner {
    --qr-connection-space: calc(48px + env(safe-area-inset-bottom));
}
</style>
